"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var NotFound_jpg_1 = __importDefault(require("../assets/images/NotFound.jpg"));

require("./Error.scss");

var NotFound = function NotFound() {
  return react_1.default.createElement("main", {
    className: "page",
    style: {
      backgroundImage: "url(" + NotFound_jpg_1.default
    }
  }, react_1.default.createElement("h1", null, "404"), react_1.default.createElement("h2", null, "Page not found"), react_1.default.createElement("p", null, "The page you were looking for does not exist"), react_1.default.createElement(react_router_dom_1.Link, {
    to: "/",
    className: "link"
  }, "Back to home"));
};

exports.default = NotFound;